var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthentication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39062 42.1655H41.8906M23.1406 4.66553V6.54053M8.14062 8.41553L10.0156 10.2905M38.1406 8.41553L36.2656 10.2905M23.1406 12.1655C18.6651 12.1655 14.3729 13.9434 11.2082 17.1081C8.04352 20.2728 6.26563 24.565 6.26562 29.0405V42.1655H40.0156V29.0405C40.0156 24.565 38.2377 20.2728 35.0731 17.1081C31.9084 13.9434 27.6162 12.1655 23.1406 12.1655Z",
    stroke: "#4DFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthentication);
export default __webpack_public_path__ + "static/media/authentication.3149fb9421b295fe76d6c0ca9e832ed2.svg";
export { ForwardRef as ReactComponent };